import { IEntityMarkerData } from 'app/map/helpers/IEntityMarkerData';
import { IQueryStorageItem } from 'app/query-builder/core/query-storage.service';

import { GetEntitiesForMapViewQuery } from 'generated/graphql';

export const StateName = 'EntityMapViewState';
export const EntityMapViewState = StateName;

export interface MarkerInfoDisplayState {
  tabbedCardStates: {
    [entityId: string]: {
      collapsed: boolean;
      selectedTab: 'profile' | 'connections';
    };
  };
}

export interface SelectedMarkerState {
  markerData: IEntityMarkerData;
  markerDisplayState: MarkerInfoDisplayState;
}
export interface EntityMapViewState {
  blank?: string;
  queryResult: GetEntitiesForMapViewQuery;
  selectedMarker: SelectedMarkerState;
  currentQuery: IQueryStorageItem;
  dataLoading: boolean;
  mapPosition: {
    shouldFitMap: boolean;
    zoom: number;
    center: [number, number];
  };
}

export const initialState: EntityMapViewState = {
  blank: null,
  selectedMarker: null,
  queryResult: null,
  currentQuery: null,
  dataLoading: false,
  mapPosition: {
    shouldFitMap: true,
    zoom: 5,
    center: [-98.50, 39]
  },
};
